import { FC } from 'react';
import { BordOneToneIcon } from 'components/NudosComponents';
import { nudosGray500 } from 'styles/styles.constants';
import './WaitingFeature.scss';

const WaitingFeature: FC = () => {
  return (
    <div className="waitingFeature">
      <BordOneToneIcon variant="clock" customWidth="32px" stroke={nudosGray500} />
      <span className="waitingFeatureTitle">Estará disponible muy pronto</span>
      <span className="waitingFeatureDescription">
        Esta funcionalidad aún está en desarrollo. Pronto estará disponible
      </span>
    </div>
  );
};

export default WaitingFeature;